import { create } from 'zustand';
import { Team } from '@/types/team';
import { teamService } from '@/services/team.service';

interface TeamsState {
  teams: Team[];
  loading: boolean;
  error: string | null;
  selectedTeam: Team | null;

  // Actions
  fetchTeams: () => Promise<void>;
  addTeam: (team: Team) => void;
  updateTeam: (id: string, team: Team) => void;
  removeTeam: (id: string) => void;
  setSelectedTeam: (team: Team | null) => void;
  clearError: () => void;
}

export const useTeamsStore = create<TeamsState>((set) => ({
  teams: [],
  loading: false,
  error: null,
  selectedTeam: null,

  fetchTeams: async () => {
    set({ loading: true, error: null });
    try {
      const teamsData = await teamService.findAll();
      const sortedTeams = [...teamsData].sort((a, b) => 
        a.name.localeCompare(b.name, 'pt-BR', { sensitivity: 'base' })
      );
      set({ teams: sortedTeams, loading: false });
    } catch (err: any) {
      set({ 
        error: err.response?.data?.message || 'Erro ao carregar times',
        loading: false 
      });
    }
  },

  addTeam: (team: Team) => {
    set((state) => ({ teams: [...state.teams, team] }));
  },

  updateTeam: (id: string, team: Team) => {
    set((state) => ({
      teams: state.teams.map((t) => (t.id === id ? team : t)),
    }));
  },

  removeTeam: (id: string) => {
    set((state) => ({
      teams: state.teams.filter((t) => t.id !== id),
      selectedTeam: state.selectedTeam?.id === id ? null : state.selectedTeam,
    }));
  },

  setSelectedTeam: (team: Team | null) => {
    set({ selectedTeam: team });
  },

  clearError: () => {
    set({ error: null });
  },
}));
